import { render } from "./inboxIndex.vue?vue&type=template&id=2573b624&scoped=true"
import script from "./inboxIndex.vue?vue&type=script&lang=js"
export * from "./inboxIndex.vue?vue&type=script&lang=js"

import "./inboxIndex.vue?vue&type=style&index=0&id=2573b624&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2573b624"]])

export default __exports__